import axios from "axios";
import * as React from "react";
import Goal from "./Goal";
import Question from "./Question";

import { NextStepModel } from "../Models/NextStepModel";

interface IDecisionTreeStates {
    currentQuestionId: string;
    previousQuestions: string[];
    nextStepModel: NextStepModel;
    nextQuestionId: string;
    isGoal: boolean;
    headingSize: string;
}

interface IDecisionTreeProps {
    title: string;
    apiUrl: string;
    firstQuestionId: string;
    nextBtnText: string;
    prevBtnText: string;
    headingSize: string;
}

export default class DecisionTree extends React.Component<IDecisionTreeProps, IDecisionTreeStates> {
    constructor(props: IDecisionTreeProps) {
        super(props);

        this.state = {
            currentQuestionId: null,
            headingSize: this.props.headingSize,
            isGoal: false,
            nextQuestionId: null,
            nextStepModel: null,
            previousQuestions: [],
        };

        this.ShowStep = this.ShowStep.bind(this);
        this.ShowPreviousStep = this.ShowPreviousStep.bind(this);
        this.SetNextStepId = this.SetNextStepId.bind(this);
        this.ShowNextStep = this.ShowNextStep.bind(this);
        this.GetNextStep(this.props.firstQuestionId, false);
    }

    public RenderButtons() {
        const prevBtn = (
            <button
                key={1}
                className="yellow-button prev-btn"
                onClick={this.ShowPreviousStep}
            >
                {this.props.prevBtnText}
            </button>
        );
        const nextBtn = (
            <button
                key={2}
                className="yellow-button"
                onClick={this.ShowNextStep}
            >
                {this.props.nextBtnText}
            </button>
        );

        if (this.props.firstQuestionId === this.state.currentQuestionId) {
            return <div className="buttons">{nextBtn}</div>;
        } else {
            return <div className="buttons">{(this.state.isGoal ? prevBtn : [prevBtn, nextBtn])}</div>;
        }
    }

    public ShowNextStep() {
        this.GetNextStep(this.state.nextQuestionId, false);
    }

    public ShowPreviousStep() {
        this.GetNextStep(this.state.previousQuestions.pop(), true);
    }

    public SetNextStepId(questionId: string) {
        this.setState({
            nextQuestionId: questionId,
        });
    }

    public GetNextStep(questionId: string, goingBack: boolean) {
        axios.post(this.props.apiUrl,
            {
                id: questionId,
            })
            .then((response) => {
                if (response && response.status === 200) {
                    this.ShowStep(response.data.result, goingBack);
                }
            });
    }

    public ShowStep(data: NextStepModel, goingBack: boolean) {
        if (!goingBack) {
            this.state.previousQuestions.push(this.state.currentQuestionId);
        }

        this.setState({
            currentQuestionId: data.questionId,
            isGoal: data.isGoal,
            nextStepModel: data,
        });
    }

    public render() {
        let bodyHtml;
        const headingSize = "h" + this.props.headingSize;
        const headingHtml = React.createElement(headingSize, {}, this.props.title);

        if (this.state.nextStepModel) {
            if (this.state.isGoal) {
                bodyHtml = (
                    <Goal
                        text={this.state.nextStepModel.text}
                    />
                );
            } else {
                bodyHtml = (
                    <Question
                        question={this.state.nextStepModel}
                        setNextQuestionId={this.SetNextStepId}
                    />
                );
            }
        } else {
            bodyHtml = (<div />);
        }

        return (
            <div className="decision-tree-module">
                {headingHtml}
                {bodyHtml}
                {this.RenderButtons()}
            </div>
        );
    }
}
